import React from 'react';
import {
    Button,
    Checkbox,
    Form,
    Input,
    Select,
    InputNumber,
    Divider,
} from 'antd';

const Description = () => {
    const { TextArea } = Input;
    return (
        <Form.Item label="Opis" name="description">
            <TextArea
                placeholder="Opis trasy"
                autoSize={{
                    minRows: 2,
                    maxRows: 6,
                }}
            />
        </Form.Item>
    );
};

export default Description;
